import React, { useEffect, useState } from "react";
import classes from "./EasyModePage2.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  updateEightTile,
  updateEighteenTile,
  updateElevenTile,
  updateFifteenTile,
  updateFiveTile,
  updateFourTile,
  updateFourteenTile,
  updateNineTile,
  updateNineteenTile,
  updateOneTile,
  updateSevenTile,
  updateSeventeenTile,
  updateSixTile,
  updateSixteenTile,
  updateTenTile,
  updateThirteenTile,
  updateThirtyTile,
  updateThreeTile,
  updateTwelveTile,
  updateTwentyEightTile,
  updateTwentyFiveTile,
  updateTwentyFourTile,
  updateTwentyNineTile,
  updateTwentyOneTile,
  updateTwentySevenTile,
  updateTwentySixTile,
  updateTwentyThreeTile,
  updateTwentyTile,
  updateTwentyTwoTile,
  updateTwoTile,
} from "../slices/tileWordSlice";
import { decreaseIndex, increaseIndex } from "../slices/activeTileSlice";
import {
  setEnteredWord1,
  setEnteredWord2,
  setEnteredWord3,
  setEnteredWord4,
  setEnteredWord5,
  setEnteredWord6,
} from "../slices/enteredWordSlice";
import {
  resetEnteredWord1,
  resetEnteredWord2,
  resetEnteredWord3,
  resetEnteredWord4,
  resetEnteredWord5,
  word1CheckHandler,
  word2CheckHandler,
  word3CheckHandler,
  word4CheckHandler,
  word5CheckHandler,
} from "../slices/word3Result";
import { setTargetWord3 } from "../slices/targetWord3Slice";
import CryptoJS from "crypto-js";
import InfoModal from "../components/InfoModal";
import GameOverModal from "../components/GameOverModal";
import WrongWordModal from "../components/WrongWordModal";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import Timer from "../components/newComponents/Timer";
import { DecreaseTime, IncreaseTimeForProgress, SetProgress } from "../slices/timeSlice";

const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(
    encryptedData,
    "my little secret"
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const EasyModePage2 = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [wrongWordModal, setWrongWordModal] = useState(false);
  const [winType, setWinType] = useState("");
  const [originalWord, setOriginalWord] = useState("");

  // 0 for lose and 1 for win

  const closeModalHandler = () => {
    setTimeout(() => {
      setModalOpen(false);
      setOriginalWord("");
      setWinType("");
      localStorage.clear();
      window.location.reload();
    }, 1000);
  };

  const closeWrongWordModal = () => {
    setWrongWordModal(false);
  };

  const dispatch = useDispatch();
  const {
    oneTile,
    twoTile,
    threeTile,
    fourTile,
    fiveTile,
    sixTile,
    sevenTile,
    eightTile,
    nineTile,
    tenTile,
    elevenTile,
    twelveTile,
    thirteenTile,
    fourteenTile,
    fifteenTile,
  } = useSelector((state) => state.tileWordSlice);

  const { index } = useSelector((state) => state.activeTileSlice);
  const { targetWord3, shuffleTargetWord3 } = useSelector(
    (state) => state.targetWord3Slice
  );

  const {
    enteredWord1,
    enteredWord2,
    enteredWord3,
    enteredWord4,
    enteredWord5,
  } = useSelector((state) => state.enteredWordSlice);

  const {
    word1Check,
    word2Check,
    word3Check,
    word4Check,
    word5Check,
    word6Check,
    enteredWord1EnterPressed,
    enteredWord2EnterPressed,
    enteredWord3EnterPressed,
    enteredWord4EnterPressed,
    enteredWord5EnterPressed,
    word1CheckDictionary,
    word2CheckDictionary,
    word3CheckDictionary,
    word4CheckDictionary,
    word5CheckDictionary,
  } = useSelector((state) => state.word3ResultSlice);

  const checkWord = (data) => {
    dispatch(data.fnc({ word: data.word, targetedWord: data.targetWord3 }));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (index == 4) {
        setTimeout(() => {
          checkWord({
            fnc: word1CheckHandler,
            word: enteredWord1,
            targetWord3: targetWord3,
          });
        }, 500);
      }
      if (index == 7) {
        console.log("enter here!");
        setTimeout(() => {
          checkWord({
            fnc: word2CheckHandler,
            word: enteredWord2,
            targetWord3: targetWord3,
          });
        }, 500);
      }
      if (index == 10) {
        setTimeout(() => {
          checkWord({
            fnc: word3CheckHandler,
            word: enteredWord3,
            targetWord3: targetWord3,
          });
        }, 500);
      }
      if (index == 13) {
        setTimeout(() => {
          checkWord({
            fnc: word4CheckHandler,
            word: enteredWord4,
            targetWord3: targetWord3,
          });
        }, 500);
      }
      if (index == 16) {
        setTimeout(() => {
          checkWord({
            fnc: word5CheckHandler,
            word: enteredWord5,
            targetWord3: targetWord3,
          });
        }, 500);
      }
    }

    if (event.key === "Backspace" || event.key === "Delete") {
      deleteKey();
      return;
    }

    if (event.key.match(/^[a-z]$/)) {
      pressKey(event.key);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    dispatch(setTargetWord3());
  }, []);

  useEffect(() => {
    if (
      word1Check == true ||
      word2Check == true ||
      word3Check == true ||
      word4Check == true ||
      word5Check == true ||
      word6Check == true
    ) {
      let word = decryptData(targetWord3);
      setOriginalWord(word);
      setModalOpen(true);
      setWinType(1);
    }
    if (
      word1CheckDictionary == false ||
      word2CheckDictionary == false ||
      word3CheckDictionary == false ||
      word4CheckDictionary == false ||
      word5CheckDictionary == false
    ) {
      if (word1CheckDictionary == false) {
        dispatch(resetEnteredWord1());
      }
      if (word2CheckDictionary == false) {
        dispatch(resetEnteredWord2());
      }
      if (word3CheckDictionary == false) {
        dispatch(resetEnteredWord3());
      }
      if (word4CheckDictionary == false) {
        dispatch(resetEnteredWord4());
      }
      if (word5CheckDictionary == false) {
        dispatch(resetEnteredWord5());
      }
      setWrongWordModal(true);
    }
  }, [
    word1Check,
    word2Check,
    word3Check,
    word4Check,
    word5Check,
    word6Check,
    word1CheckDictionary,
    word2CheckDictionary,
    word3CheckDictionary,
    word4CheckDictionary,
    word5CheckDictionary,
  ]);

  useEffect(() => {
    if (enteredWord5EnterPressed && word5CheckDictionary) {
      let word = decryptData(targetWord3);
      setOriginalWord(word);
      setModalOpen(true);
      setWinType(0);
    }
  }, [enteredWord5EnterPressed, word5CheckDictionary]);

  const pressKey = (key) => {
    if (enteredWord1.length == 3 && !enteredWord1EnterPressed) {
      return;
    }

    if (enteredWord2.length == 3 && !enteredWord2EnterPressed) {
      return;
    }

    if (enteredWord3.length == 3 && !enteredWord3EnterPressed) {
      return;
    }

    if (enteredWord4.length == 3 && !enteredWord4EnterPressed) {
      return;
    }

    if (enteredWord5.length == 3 && !enteredWord5EnterPressed) {
      return;
    }
    if (index == 1) {
      dispatch(updateOneTile(String(key).toUpperCase()));
      dispatch(setEnteredWord1([String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 2) {
      dispatch(updateTwoTile(String(key).toUpperCase()));
      dispatch(setEnteredWord1([oneTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 3) {
      dispatch(updateThreeTile(String(key).toUpperCase()));
      dispatch(setEnteredWord1([oneTile, twoTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 4) {
      dispatch(updateFourTile(String(key).toUpperCase()));
      dispatch(setEnteredWord2([String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 5) {
      dispatch(updateFiveTile(String(key).toUpperCase()));
      dispatch(setEnteredWord2([fourTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 6) {
      dispatch(updateSixTile(String(key).toUpperCase()));
      dispatch(
        setEnteredWord2([, fourTile, fiveTile, String(key).toUpperCase()])
      );
      dispatch(increaseIndex());
    }
    if (index == 7) {
      dispatch(updateSevenTile(String(key).toUpperCase()));
      dispatch(setEnteredWord3([String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 8) {
      dispatch(updateEightTile(String(key).toUpperCase()));
      dispatch(setEnteredWord3([sevenTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 9) {
      dispatch(updateNineTile(String(key).toUpperCase()));
      dispatch(
        setEnteredWord3([sevenTile, eightTile, String(key).toUpperCase()])
      );
      dispatch(increaseIndex());
    }
    if (index == 10) {
      dispatch(updateTenTile(String(key).toUpperCase()));
      dispatch(setEnteredWord4([String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 11) {
      dispatch(updateElevenTile(String(key).toUpperCase()));
      dispatch(setEnteredWord4([tenTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 12) {
      dispatch(updateTwelveTile(String(key).toUpperCase()));
      dispatch(
        setEnteredWord4([tenTile, elevenTile, String(key).toUpperCase()])
      );
      dispatch(increaseIndex());
    }
    if (index == 13) {
      dispatch(updateThirteenTile(String(key).toUpperCase()));
      dispatch(setEnteredWord5([String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 14) {
      dispatch(updateFourteenTile(String(key).toUpperCase()));
      dispatch(setEnteredWord5([thirteenTile, String(key).toUpperCase()]));
      dispatch(increaseIndex());
    }
    if (index == 15) {
      dispatch(updateFifteenTile(String(key).toUpperCase()));
      dispatch(
        setEnteredWord5([thirteenTile, fourteenTile, String(key).toUpperCase()])
      );
      dispatch(increaseIndex());
    }
  };

  const deleteKey = () => {
    if (index == 16 && enteredWord5EnterPressed) {
      return;
    }
    if (index == 13 && enteredWord4EnterPressed) {
      return;
    }
    if (index == 10 && enteredWord3EnterPressed) {
      return;
    }
    if (index == 7 && enteredWord2EnterPressed) {
      return;
    }
    if (index == 4 && enteredWord1EnterPressed) {
      return;
    }
    if (index == 2) {
      dispatch(updateOneTile(""));
      dispatch(setEnteredWord1([""]));
      dispatch(decreaseIndex());
    }
    if (index == 3) {
      dispatch(updateTwoTile(""));
      dispatch(setEnteredWord1([""]));
      dispatch(decreaseIndex());
    }
    if (index == 4) {
      dispatch(updateThreeTile(""));
      dispatch(setEnteredWord1([""]));
      dispatch(decreaseIndex());
    }
    if (index == 5) {
      dispatch(updateFourTile(""));
      dispatch(setEnteredWord2([""]));
      dispatch(decreaseIndex());
    }
    if (index == 6) {
      dispatch(updateFiveTile(""));
      dispatch(setEnteredWord2([""]));
      dispatch(decreaseIndex());
    }
    if (index == 7) {
      dispatch(updateSixTile(""));
      dispatch(setEnteredWord2([""]));
      dispatch(decreaseIndex());
    }
    if (index == 8) {
      dispatch(updateSevenTile(""));
      dispatch(setEnteredWord3([""]));
      dispatch(decreaseIndex());
    }
    if (index == 9) {
      dispatch(updateEightTile(""));
      dispatch(setEnteredWord3([""]));
      dispatch(decreaseIndex());
    }
    if (index == 10) {
      dispatch(updateNineTile(""));
      dispatch(setEnteredWord3([""]));
      dispatch(decreaseIndex());
    }
    if (index == 11) {
      dispatch(updateTenTile(""));
      dispatch(setEnteredWord4([""]));
      dispatch(decreaseIndex());
    }
    if (index == 12) {
      dispatch(updateElevenTile(""));
      dispatch(setEnteredWord4([""]));
      dispatch(decreaseIndex());
    }
    if (index == 13) {
      dispatch(updateTwelveTile(""));
      dispatch(setEnteredWord4([""]));
      dispatch(decreaseIndex());
    }
    if (index == 14) {
      dispatch(updateThirteenTile(""));
      dispatch(setEnteredWord5([""]));
      dispatch(decreaseIndex());
    }
    if (index == 15) {
      dispatch(updateFourteenTile(""));
      dispatch(setEnteredWord5([""]));
      dispatch(decreaseIndex());
    }
    if (index == 16) {
      dispatch(updateFifteenTile(""));
      dispatch(setEnteredWord5([""]));
      dispatch(decreaseIndex());
    }
  };

  const { time, progress } = useSelector((state) => state?.timeSlice);

  useEffect(() => {
    if (time > 0) {
      const timeoutId = setTimeout(() => {
        dispatch(DecreaseTime());
        dispatch(IncreaseTimeForProgress());
        dispatch(SetProgress());
      }, 1000);

      return () => clearTimeout(timeoutId);
    } else {
        // show popup
        let word = decryptData(targetWord3);
        setOriginalWord(word);
        setModalOpen(true);
        setWinType(0);
    }
  }, [time, dispatch]);

  return (
    <>
      <Layout>
        <Timer progress={progress} />
        <Card>
          <CardHeader title="Guess the 3 Letter Word!" />
          <div className={classes.word}>
            <p className={classes.shuffled_word}>{shuffleTargetWord3}</p>
          </div>
          <div className={classes.tiles_grid}>
            <div
              className={`${classes.tile} ${
                word1Check?.length > 0 &&
                word1Check.find((item) => item.index === 0) &&
                classes.tile_character_right
              } ${enteredWord1EnterPressed && classes.flip_tile}`}
            >
              {oneTile}
            </div>
            <div
              className={`${classes.tile} ${
                word1Check?.length > 0 &&
                word1Check.find((item) => item.index === 1) &&
                classes.tile_character_right
              } ${enteredWord1EnterPressed && classes.flip_tile}`}
            >
              {twoTile}
            </div>
            <div
              className={`${classes.tile} ${
                word1Check?.length > 0 &&
                word1Check.find((item) => item.index === 2) &&
                classes.tile_character_right
              } ${enteredWord1EnterPressed && classes.flip_tile}`}
            >
              {threeTile}
            </div>
            <div
              className={`${classes.tile} ${
                word2Check?.length > 0 &&
                word2Check.find((item) => item.index === 0) &&
                classes.tile_character_right
              } ${enteredWord2EnterPressed && classes.flip_tile}`}
            >
              {fourTile}
            </div>
            <div
              className={`${classes.tile} ${
                word2Check?.length > 0 &&
                word2Check.find((item) => item.index === 1) &&
                classes.tile_character_right
              } ${enteredWord2EnterPressed && classes.flip_tile}`}
            >
              {fiveTile}
            </div>
            <div
              className={`${classes.tile} ${
                word2Check?.length > 0 &&
                word2Check.find((item) => item.index === 2) &&
                classes.tile_character_right
              } ${enteredWord2EnterPressed && classes.flip_tile}`}
            >
              {sixTile}
            </div>
            <div
              className={`${classes.tile} ${
                word3Check?.length > 0 &&
                word3Check.find((item) => item.index === 0) &&
                classes.tile_character_right
              } ${enteredWord3EnterPressed && classes.flip_tile}`}
            >
              {sevenTile}
            </div>
            <div
              className={`${classes.tile} ${
                word3Check?.length > 0 &&
                word3Check.find((item) => item.index === 1) &&
                classes.tile_character_right
              } ${enteredWord3EnterPressed && classes.flip_tile}`}
            >
              {eightTile}
            </div>
            <div
              className={`${classes.tile} ${
                word3Check?.length > 0 &&
                word3Check.find((item) => item.index === 2) &&
                classes.tile_character_right
              } ${enteredWord3EnterPressed && classes.flip_tile}`}
            >
              {nineTile}
            </div>
            <div
              className={`${classes.tile} ${
                word4Check?.length > 0 &&
                word4Check.find((item) => item.index === 0) &&
                classes.tile_character_right
              } ${enteredWord4EnterPressed && classes.flip_tile}`}
            >
              {tenTile}
            </div>
            <div
              className={`${classes.tile} ${
                word4Check?.length > 0 &&
                word4Check.find((item) => item.index === 1) &&
                classes.tile_character_right
              } ${enteredWord4EnterPressed && classes.flip_tile}`}
            >
              {elevenTile}
            </div>
            <div
              className={`${classes.tile} ${
                word4Check?.length > 0 &&
                word4Check.find((item) => item.index === 2) &&
                classes.tile_character_right
              } ${enteredWord4EnterPressed && classes.flip_tile}`}
            >
              {twelveTile}
            </div>
            <div
              className={`${classes.tile} ${
                word5Check?.length > 0 &&
                word5Check.find((item) => item.index === 0) &&
                classes.tile_character_right
              } ${enteredWord5EnterPressed && classes.flip_tile}`}
            >
              {thirteenTile}
            </div>
            <div
              className={`${classes.tile} ${
                word5Check?.length > 0 &&
                word5Check.find((item) => item.index === 1) &&
                classes.tile_character_right
              } ${enteredWord5EnterPressed && classes.flip_tile}`}
            >
              {fourteenTile}
            </div>
            <div
              className={`${classes.tile} ${
                word5Check?.length > 0 &&
                word5Check.find((item) => item.index === 2) &&
                classes.tile_character_right
              } ${enteredWord5EnterPressed && classes.flip_tile}`}
            >
              {fifteenTile}
            </div>
          </div>
        </Card>

        {modalOpen && (
          <GameOverModal
            closeModalHandler={closeModalHandler}
            winType={winType}
            originalWord={originalWord}
          />
        )}
        {wrongWordModal && (
          <WrongWordModal closeWrongWordModal={closeWrongWordModal} />
        )}

        <div className={classes.keyboard_container}>
          <div className={classes.keypad_1}>
            <div className={classes.key} onClick={() => pressKey("Q")}>
              Q
            </div>
            <div className={classes.key} onClick={() => pressKey("W")}>
              W
            </div>
            <div className={classes.key} onClick={() => pressKey("E")}>
              E
            </div>
            <div className={classes.key} onClick={() => pressKey("R")}>
              R
            </div>
            <div className={classes.key} onClick={() => pressKey("T")}>
              T
            </div>
            <div className={classes.key} onClick={() => pressKey("Y")}>
              Y
            </div>
            <div className={classes.key} onClick={() => pressKey("U")}>
              U
            </div>
            <div className={classes.key} onClick={() => pressKey("I")}>
              I
            </div>
            <div className={classes.key} onClick={() => pressKey("O")}>
              O
            </div>
            <div className={classes.key} onClick={() => pressKey("P")}>
              P
            </div>
          </div>
          <div className={classes.keypad_2}>
            <div className={classes.key} onClick={() => pressKey("A")}>
              A
            </div>
            <div className={classes.key} onClick={() => pressKey("S")}>
              S
            </div>
            <div className={classes.key} onClick={() => pressKey("D")}>
              D
            </div>
            <div className={classes.key} onClick={() => pressKey("F")}>
              F
            </div>
            <div className={classes.key} onClick={() => pressKey("G")}>
              G
            </div>
            <div className={classes.key} onClick={() => pressKey("H")}>
              H
            </div>
            <div className={classes.key} onClick={() => pressKey("J")}>
              J
            </div>
            <div className={classes.key} onClick={() => pressKey("K")}>
              K
            </div>
            <div className={classes.key} onClick={() => pressKey("L")}>
              L
            </div>
          </div>
          <div className={classes.keypad_3}>
            <div
              className={classes.key_large}
              onClick={() => handleKeyDown({ key: "Enter" })}
            >
              ENTER
            </div>
            <div className={classes.key} onClick={() => pressKey("Z")}>
              Z
            </div>
            <div className={classes.key} onClick={() => pressKey("X")}>
              X
            </div>
            <div className={classes.key} onClick={() => pressKey("C")}>
              C
            </div>
            <div className={classes.key} onClick={() => pressKey("V")}>
              V
            </div>
            <div className={classes.key} onClick={() => pressKey("B")}>
              B
            </div>
            <div className={classes.key} onClick={() => pressKey("N")}>
              N
            </div>
            <div className={classes.key} onClick={() => pressKey("M")}>
              M
            </div>
            <div className={classes.key_large} onClick={deleteKey}>
              Backspace
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default EasyModePage2;
